var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarAdmin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBF3FA"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M217.6,505.2c2.8,0.4,6,0.8,8.8,1.2C223.6,506,220.4,505.6,217.6,505.2L217.6,505.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M226.4,506.4c2.8,0.4,6,0.4,8.8,0.8l0,0C232.4,507.2,229.6,506.8,226.4,506.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M254.4,308.4C254,308.4,254,308.8,254.4,308.4c-0.4,0-0.4,0-0.8,0H254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M272.4,507.2c6-0.4,12-1.2,18-2l0,0c-12,1.6-24,2.8-36.4,2.8c-6.4,0-12.4-0.4-18.4-0.8 c-22.8-56.8-34.8-108.8-41.2-151.6c13.6-43.2,59.6-46.8,59.6-46.8s46,3.6,59.6,46.8C307.2,398.4,295.2,450.4,272.4,507.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD3BA"
    },
    d: "M308.8,239.6c0,0,7.2,38.8-54.4,68.8h-0.8c-61.6-30-54.4-68.8-54.4-68.8s0,0-0.4,0 c0-0.4,0.4-1.2,0.4-1.6c15.2,18.4,34.4,30.4,54.8,30.4s39.6-12,54.8-30.8C308.8,238.8,309.2,239.2,308.8,239.6 C309.2,240,308.8,239.6,308.8,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD3BA"
    },
    d: "M210.8,250.4l-10.4,4.8c-2.4-9.2-1.6-15.6-1.6-15.6s0,0-0.4,0c0-0.4,0.4-1.2,0.4-1.6 C202.8,242.4,206.8,246.8,210.8,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD3BA"
    },
    d: "M308.8,239.6c0,0,1.2,6-1.6,15.6l-10.4-4.8c4-3.6,8-7.6,11.6-12.4 C308.8,238.8,309.2,239.2,308.8,239.6C309.2,240,308.8,239.6,308.8,239.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M254.4,308.4C254,308.4,254,308.8,254.4,308.4c-0.4,0-0.4,0-0.8,0H254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M275.6,314.4l-7.2,21.2h-29.2l-7.2-21.2c12-5.2,21.6-6,21.6-6S264,309.6,275.6,314.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M272.4,507.2c1.6,0,2.8-0.4,4.4-0.4l0,0C275.6,507.2,274,507.2,272.4,507.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M287.2,467.2c-4.4,13.2-9.2,26.4-14.4,40c-6,0.4-12.4,0.8-18.4,0.8c-13.2,0-18.4-0.8-18.4-0.8 c-5.6-13.6-10.4-26.8-14.4-40l18.8-131.6h29.2L287.2,467.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E293B"
    },
    d: "M459.6,403.2c-42.8,58.8-110,98.4-186.8,104c22.8-56.8,34.8-108.8,41.2-151.6 c0,1.2,16-57.6,7.6-93.6l109.6,52.8L459.6,403.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E293B"
    },
    d: "M235.6,507.2c-76.8-5.6-144.4-45.2-186.8-104l28.4-88.4L186.8,262c-8.4,35.2,6.8,92.8,7.6,93.6l0,0 C200.8,398.4,212.8,450.4,235.6,507.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.8,239.6c0,0,7.2,38.8-54.8,68.8c0,0,46,3.6,59.6,46.8C314,357.2,339.2,262.8,308.8,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.2,239.6c0,0-7.2,38.8,54.8,68.8c0,0-46,3.6-59.6,46.8C194,357.2,168.8,262.8,199.2,239.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD3BA"
    },
    d: "M324,195.6c-7.6,22.8-10,35.2-10.4,36l0,0c-16,22-36.8,36.8-59.6,36.8c-21.2,0-41.2-13.2-56.8-33.2 c0.4,0.4,0.4,0.4,0.4,0.4C164,194.4,187.2,118,187.2,118c16.8,19.2,71.2,20.4,71.2,20.4c-23.6-4-27.6-22.8-27.6-22.8 c4,11.6,56.8,18.8,56.8,18.8C342,142.4,324,195.6,324,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E293B"
    },
    d: "M222.4,38.4c0,0,74-29.6,112,37.6c40.4,71.6-10.4,149.6-20.8,156c0,0,2.8-12.4,10.4-36.4 c0,0,18-53.2-36.4-61.2c0,0-52.8-7.2-56.8-18.8c0,0,4,19.2,27.6,22.8c0,0-54.4-1.2-71.2-20.4c0,0-23.2,76.4,10.4,117.6 c0,0-58.4-46.8-51.2-118.8C146.4,117.2,143.6,18.4,222.4,38.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAdmin);
export default __webpack_public_path__ + "static/media/avatar-admin.11435721611e1a1f69667677f5e5516e.svg";
export { ForwardRef as ReactComponent };